import StyledTableHead from 'Components/StyledTableHead'
import type { EpassiPaymentEventShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter } from 'Util/formatters'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const EpassiPaymentEvents: FC<{
  events: EpassiPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      {events.map(event => (
        <TableRow key={event.type + event.id}>
          <TableCell>{event.type}</TableCell>
          <TableCell>{datetimeFormatter(event.created)}</TableCell>
          <TableCell>{event.description}</TableCell>
        </TableRow>
      ))}
    </>
  )
}

const EpassiPaymentInfo: FC<{
  events: EpassiPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Epassi)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableHead>
        <TableRow>
          <TableCell>{t`Type`}</TableCell>
          <TableCell>{t`Created`}</TableCell>
          <TableCell>{t`Description`}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length > 0 ? (
          <EpassiPaymentEvents events={events} />
        ) : (
          <TableRow>
            <TableCell>{t`No payment events available`}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  )
}

export { EpassiPaymentInfo }
